var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "input-group" }, [
    _vm.invoice.status != 3
      ? _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newStatus,
                expression: "newStatus",
              },
            ],
            staticClass: "form-control",
            on: {
              change: [
                function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.newStatus = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                () => _vm.onStatusChange(_vm.newStatus),
              ],
            },
          },
          _vm._l(_vm.getSortedInvoiceStatuses(), function (status) {
            return !status.invoiceTypeOnly ||
              status.invoiceTypeOnly.includes(_vm.invoice.type)
              ? _c("option", { domProps: { value: status.id } }, [
                  _vm._v(_vm._s(status.title) + "\n    "),
                ])
              : _vm._e()
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.invoice.type === 1
      ? _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.invoice.sub_status,
                expression: "invoice.sub_status",
              },
            ],
            staticClass: "form-control",
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.invoice,
                  "sub_status",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              },
            },
          },
          [
            _c("option", { attrs: { value: "" } }, [_vm._v("Без подсклада")]),
            _vm._v(" "),
            _vm._l(_vm.getSortedSubStores(), function (s) {
              return _c("option", { domProps: { value: s.id } }, [
                _vm._v(_vm._s(s.title)),
              ])
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }